/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'share-modal.accordion-button-label':
    '{entity, select, project {Quem recebe atualizações semanais do projeto?} goal {Quem recebe atualizações semanais de metas?} other {Quem recebe atualizações semanais?}}',
  'share-modal.add-as-follower-checkbox-label': 'Adicionar como seguidor',
  'share-modal.add-as-follower-checkbox-tooltip':
    '{entity, select, project {Os seguidores recebem uma atualização semanal sobre o projeto no resumo} goal {Os seguidores recebem uma atualização semanal sobre a meta no resumo} other {Os seguidores recebem uma atualização semanal no resumo}}',
  'share-modal.all-tab-label': 'Todos',
  'share-modal.contributors-tab-label': 'Colaboradores',
  'share-modal.followers-tab-label': 'Seguidores',
  'share-modal.followers-title': 'Seguidores',
  'share-modal.footer.access-level-disclaimer':
    '{entity, select, project {Todos com acesso ao espaço de trabalho podem ver esse projeto.} goal {Todos com acesso ao espaço de trabalho podem ver essa meta.} other {Todos com acesso ao espaço de trabalho podem ver isso.}}',
  'share-modal.footer.access-level-private-disclaimer':
    '{entity, select, project {Projeto privado} goal {Meta privada} other {}}',
  'share-modal.footer.copy-link-button': 'Copiar link',
  'share-modal.footer.copy-link-button.copied-tooltip': 'Copiado!',
  'share-modal.footer.copy-link-button.tooltip':
    '{entity, select, project {Copiar link para o projeto} goal {Copiar link para a meta} other {Copiar o link para }}',
  'share-modal.modal.user-picker.add-more-placeholder': 'Adicionar mais pessoas',
  'share-modal.share-button': 'Compartilhar',
  'share-modal.share-title': 'Compartilhar',
  'share-modal.user-item.can-edit-label': 'Pode editar',
  'share-modal.user-picker.placeholder': 'Pesquise e convide pessoas',
  'shareModal.followers-empty-state.default-title': 'Faltando as principais partes interessadas?',
  'shareModal.followers-empty-state.goal-cta':
    'Verifique se eles receberam a atualização mais recente sobre a meta no resumo mensal, adicionando como seguidores ou conectando um canal do Slack ou do MS Teams',
  'shareModal.followers-empty-state.project-cta':
    'Adicione as principais equipes e partes interessadas como seguidores para que continuem atualizadas. Conecte um canal para compartilhar atualizações direto no chat.',
  'shareModal.followers-empty-state.project-title': 'Alcance um público maior adicionando seguidores',
};
